export default __webpack_public_path__ + "static/media/my-tickets-active.c5e70804.svg";